import { NotFound } from '@components';

const NoRoutePage = () => {
  return (
    <NotFound />
  );
}

export default NoRoutePage;
